module.exports = __webpack_public_path__ + "img/avatar-s-4.jpg";